export const firebaseConfig = {
  apiKey: 'AIzaSyB2FFoEVqU9fdq8oMw2R2-6JLP7ZFq26sI',
  authDomain: 'boodschapp-91613.firebaseapp.com',
  databaseURL: 'https://boodschapp-91613.firebaseio.com',
  projectId: 'boodschapp-91613',
  storageBucket: 'boodschapp-91613.appspot.com',
  messagingSenderId: '262152208010'
}



// WEBPACK FOOTER //
// ./src/config/configFirebase.js